module.exports = __webpack_public_path__ + "img/selected2-min.cd5433da.png";